<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<!-- decoy field -->
<input type="text" style="height:0px;position: absolute; left:-9999px;" autocomplete="username" name="api_url"/>
<input type="password" style="height:0px;position: absolute; left:-9999px;" autocomplete="new-password"  name="api_key"/>

<div class="h-full center-container">
  <div class="grid w-full">
    <div class="card">
      <p-toolbar>
        <div class="p-toolbar-group-center w-full">
          <div class="field mb-0 col-12">
            <div class="col-6 flex align-content-left justify-content-start align-items-center">
              <h3 #componentTitleHeader class="m-0">Lot Settings {{ locationId }}</h3>
            </div>
            <div class="col-6 flex align-content-center justify-content-end align-items-center gap-2" *ngIf="devOptsEnabled">
              <p-button #devClearConfigurationButton label="Clear Configuration" (click)="confirmClearConfiguration()"></p-button>
              <p-button label="Import Configuration" (click)="importConfDialog = true"></p-button>
              <p-button label="View Configuration JSON" (click)="importedConfJSON = '';viewConfJSONDetails = true"></p-button>
            </div>
          </div>
        </div>
      </p-toolbar>
      <div class="col-12">

        <div *ngIf="!loadingSettings; else spinner">
          <form [formGroup]="settingsForm" autocomplete="off">
            <div class="formgrid grid p-fluid mt-5">
              <div class="field col-12 md:col-6  xl:col-2">
                <div class="field-checkbox mb-0 justify-content-between w-full">
                  <label for="wps_active" class="w-6 label-required">Device Active</label>
                  <p-inputSwitch pInputText id="wps_active" (click)="saveSettingsWhenActivated();" formControlName="wps_active" class="border-none w-auto" />
                </div>
              </div>
              <div class="field col-12 md:col-6  xl:col-2">
                <div class="field mb-0 justify-content-between w-full">
                  <label for="parking_device" class="label-required w-full">Parkig Device</label>
                  <p-dropdown id="parking_device" formControlName="parking_device" [options]="deviceParkingOptions"
                    optionLabel="name" optionValue="code" appendTo="body" class="w-full" (onChange)="parkingDeviceChanged($event)">
                  </p-dropdown>
                </div>
              </div>

              <div class="field col-12 md:col-6  xl:col-4">
                <label for="api_url" class="label-required w-full">Device URL</label>
                <input pInputText id="api_url" formControlName="api_url" />

                <div *ngIf="formSubmitted && settingsForm.controls['api_url'].errors">
                  <div class="ui-messages-error" *ngIf="settingsForm.controls['api_url'].errors?.['required']">Please
                    enter device URL.
                  </div>
                </div>
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="api_key" class="label-required w-full">Device Key</label>
                <input pInputText type="password" id="api_key" formControlName="api_key" />

                <div *ngIf="formSubmitted && settingsForm.controls['api_key'].errors">
                  <div class="ui-messages-error" *ngIf="settingsForm.controls['api_key'].errors?.['required']">Please
                    enter device key.
                  </div>
                </div>
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="default_company_id" class="label-required w-full">Default Groupid (Company ID)</label>
                <p-dropdown id="default_company_id" formControlName="default_company_id" [options]="groupIdOptions"
                  optionLabel="name" optionValue="code" appendTo="body" class="w-full">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['default_company_id'].errors">
                  <div class="ui-messages-error"
                    *ngIf="settingsForm.controls['default_company_id'].errors?.['required']">Please select default
                    company.
                  </div>
                </div>

              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="card_function_setting" class="label-required w-full">Card Function</label>
                <p-dropdown id="card_function_setting" formControlName="card_function_setting"
                  [options]="cardFunctionOptions" optionLabel="name" optionValue="code" appendTo="body" class="w-full">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['card_function_setting'].errors">
                  <div class="ui-messages-error"
                    *ngIf="settingsForm.controls['card_function_setting'].errors?.['required']">Please select card function.
                  </div>
                </div>

              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="group_passback_setting" class="label-required w-full">Anti-Passback <i 
                class="pi pi-question-circle text-primary cursor-pointer" [pTooltip]="antiPassHelpText" 
                [escape]="false" tooltipPosition="right"></i>
              </label>
                <p-dropdown id="group_passback_setting" formControlName="group_passback_setting"
                  [options]="antiPassbackOptions" optionLabel="name" optionValue="code" appendTo="body" class="w-full">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['group_passback_setting'].errors">
                  <div class="ui-messages-error"
                    *ngIf="settingsForm.controls['group_passback_setting'].errors?.['required']">Please select passback.
                  </div>
                </div>

              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <div class="field-checkbox mb-0 justify-content-between w-full">
                  <label for="set_apb_for_new_members" class="w-full">Set APB For New Members</label>
                  <p-checkbox id="set_apb_for_new_members" formControlName="set_apb_for_new_members"
                    [binary]="true" inputId="binary"></p-checkbox>
                </div>
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <div class="field-checkbox mb-0 justify-content-between w-full">
                  <label for="hide_empty_surepark_groups" class="w-full">Hide Empty SUREPARK Groups</label>
                  <p-checkbox id="hide_empty_surepark_groups" formControlName="hide_empty_surepark_groups"
                    [binary]="true" inputId="binary"></p-checkbox>
                </div>
              </div>

              <div class="field col-12">
                <hr style="width:100%;">
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="default_lot_names" class="label-required w-full">Default Group Stations</label>
                <p-multiSelect id="default_lot_names" formControlName="default_lot_names" [options]="lotIdOptions"
                  optionLabel="name" optionValue="code" appendTo="body" class="w-full"
                  (onChange)="defaultGroupStationsChanged($event)">
                </p-multiSelect>

                <div *ngIf="formSubmitted && settingsForm.controls['default_lot_names'].errors">
                  <div class="ui-messages-error"
                    *ngIf="settingsForm.controls['default_lot_names'].errors?.['required']">Please select station
                    groups(s).
                  </div>
                </div>
                <div *ngIf="settingsForm.errors?.['mutuallyExclusive']" class="ui-messages-error">
                  Please select either Default Group Stations OR Default Group Lot, not both.
                </div>
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="default_timezone_groups" class="label-required w-full">Default Timezone Group</label>
                <p-dropdown id="default_timezone_groups" formControlName="default_timezone_groups"
                  [options]="timezoneGroupOptions" optionLabel="name" optionValue="code" appendTo="body" class="w-full"
                  [showClear]="true" (onChange)="defaultTimezoneGroupChanged($event)">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['default_timezone_groups'].errors">
                  <div class="ui-messages-error"
                    *ngIf="settingsForm.controls['default_timezone_groups'].errors?.['required']">Please select default
                    timezone group.</div>
                </div>
                <div *ngIf="settingsForm.errors?.['timezoneExclusive']" class="ui-messages-error">
                  Please select either Default Timezone Group OR Default Timezone, not both.
                </div>
              </div>

              <div class="field col-12">
                or
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="api_lotid" class="label-required w-full">Default Group Lot</label>
                <p-dropdown id="api_lotid" formControlName="api_lotid" [options]="lotIdOptions" optionLabel="name"
                  optionValue="code" appendTo="body" class="w-full" [showClear]="true"
                  (onChange)="defaultGroupLotChanged($event)">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['api_lotid'].errors">
                  <div class="ui-messages-error" *ngIf="settingsForm.controls['api_lotid'].errors?.['required']">Please
                    select default lot(s).
                  </div>
                </div>
                <div *ngIf="settingsForm.errors?.['mutuallyExclusive']" class="ui-messages-error">
                  Please select either Default Group Stations OR Default Group Lot, not both.
                </div>
              </div>

              <div class="field col-12 md:col-6 xl:col-4">
                <label for="api_timezoneid" class="label-required w-full">Default Timezone</label>
                <p-dropdown id="api_timezoneid" formControlName="api_timezoneid" [options]="timezoneOptions"
                  optionLabel="name" optionValue="code" appendTo="body" class="w-full" [showClear]="true"
                  (onChange)="defaultTimezoneChanged($event)">
                </p-dropdown>

                <div *ngIf="formSubmitted && settingsForm.controls['api_timezoneid'].errors">
                  <div class="ui-messages-error" *ngIf="settingsForm.controls['api_timezoneid'].errors?.['required']">
                    Please select default timezone.</div>
                </div>
                <div *ngIf="settingsForm.errors?.['timezoneExclusive']" class="ui-messages-error">
                  Please select either Default Timezone Group OR Default Timezone, not both.
                </div>
              </div>

            <div class="field col-12">
              <hr style="width:100%;">
            </div>

            <div class="field col-12">
              <div class="col-6 flex align-content-left justify-content-start">
                <a pButton class="no-underline w-auto" severity="primary" label="Back to Portal" (click)="backToPortal()"></a>
              </div>
              <div class="col-6 flex align-content-center justify-content-end">
                <p-button class="col-offset-6 mt-2" label="Save Settings" (click)="saveSettings()"
                  [loading]="savingSettings"></p-button>
              </div>
            </div>

        </div>
        </form>
      </div>
    </div>
    <p-dialog header="Configuration JSON" [modal]="true" [(visible)]="viewConfJSONDetails" [style]="{ width: '50rem' }"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [draggable]="false" [resizable]="false">
      <pre>
          {{ settingsForm.value | json }}
      </pre>
      <p-button label="Copy JSON" (click)="copyJSON()"></p-button>
    </p-dialog>
    <p-dialog header="Configuration JSON" [modal]="true" [(visible)]="importConfDialog" [style]="{ width: '50rem' }"
      [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [draggable]="false" [resizable]="false">
      <textarea style="width: 100%;min-height: 250px;" pInputTextarea [(ngModel)]="importedConfJSON" class="field"></textarea>

      <p-button label="Update Configurations" (click)="importJSON()" [disabled]="!importedConfJSON"></p-button>
    </p-dialog>
  </div>
  <ng-template #spinner>
    <p-progressSpinner></p-progressSpinner>
  </ng-template>
</div>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
